import React, { Component } from 'react';

import { ProgressItem } from './ProgressItem';

// Served by this application rather than fetched from 51degrees.com. A
// cross-site request for the logo is refused outright by privacy settings
// and extensions that block third party requests, which left the header
// with no brand at all. This is the same wordmark under the same file name
// that the website serves.
let logo = "/images/logo.png";

export class Header extends Component {
    displayName = Header.name;

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
            }

    onClick = (_section) => {
        const { goto } = this.props;
        goto(_section);
    }

    render() {
        return (
            <div className="g-header">
                <h1 className="c-brand">
                    <a href="#" className="c-brand__link" onClick={(e) => { e.preventDefault(); this.onClick(1); }}>
                        <img src={logo} alt="51 Degrees Cloud Configurator" className="c-brand__image" />
                    </a>
                </h1>
                <ul className="c-progress">
                    <ProgressItem value={1} onClick={this.onClick} enabled active={this.props.section} name={"Configure Properties"}/>
                    <ProgressItem value={2} onClick={this.onClick} enabled={this.props.termsAgreed} active={this.props.section} name={"Add/Get License Key"}/>
                    <ProgressItem value={3} onClick={this.onClick} enabled={this.props.termsAgreed && this.props.hasResource} active={this.props.section} name={"Implement"}/>
                </ul>
            </div>    
        );
    }
}